import { signInAnonymously } from "firebase/auth";
import { auth } from "../../configs/firebaseConfig";
import { waitForAuthInitialization } from "./authState";

let anonymousAuthRequest = null;

export async function ensureAnonymousAuth() {
  await waitForAuthInitialization();

  if (auth.currentUser) {
    return auth.currentUser;
  }

  if (!anonymousAuthRequest) {
    anonymousAuthRequest = signInAnonymously(auth)
      .then((userCredential) => userCredential.user)
      .finally(() => {
        anonymousAuthRequest = null;
      });
  }

  return anonymousAuthRequest;
}
